import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
});

export default new Vuex.Store({
    state: {
        corporation: null,
        corporationInfo: {},
        sessionManageCalled: false,
        isLoggedIn: false,
        user: null,
        stayAliveData: {},
        categories: {},
        listType: 'list',
    },
    mutations: {
        setCorporation(state, data) {
            state.corporation = data;
        },
        toggleSessionManageCalled(state) {
            state.sessionManageCalled = !state.sessionManageCalled;
        },
        setIsLoggedIn(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn;
        },
        setUser(state, user) {
            state.user = user;
        },
        setCorporationInfo(state, corporationInfo) {
            state.corporationInfo = corporationInfo;
        },
        setStayAliveData(state, stayAliveData) {
            state.stayAliveData = stayAliveData;
        },
        setCategories(state, categoryData) {
            state.categories[categoryData[0]] = categoryData[1];
        },
        resetCategories(state) {
            state.categories = {};
        },
        changeType(state, listType) {
            state.listType = listType;
        },
    },
    actions: {},
    modules: {},
    plugins: [vuexLocal.plugin],
});